import { useState, useEffect } from "react";
import api from "../../../services/api";

export const FetchStatus = {
  SUCCESS: "success",
  ERROR: "error",
  LOADING: "loading"
};

const mockedResponse = {
  id: 2502,
  operacao_set: [
    {
      id: 3543,
      parcela_set: [
        {
          id: 6253,
          dt_cadastro: "2023-11-13",
          last_update: "2024-01-08",
          is_deleted: true,
          cod_registro: "15",
          num_parcela: 30,
          dt_vencimento: "2023-10-10",
          dias_em_atraso: 38,
          valor_parcela: 127.62,
          valor_multa: 0.0,
          valor_mora: 3.6,
          valor_outros_contratado: 0.0,
          valor_outros_atraso: 0.0,
          valor_juros_contratado: 0.0,
          valor_juros_atraso: 0.0,
          valor_atualizado: 131.22,
          restricao_serasa: "1",
          restricao_spc: "0",
          restricao_boa_vista: "0",
          id_operacao: "00000000000032835400",
          id_sitaucao: "01",
          dt_remocao_txt: "2023-11-21",
          operacao: 3543
        },
        {
          id: 6254,
          dt_cadastro: "2023-11-13",
          last_update: "2024-01-08",
          is_deleted: true,
          cod_registro: "15",
          num_parcela: 31,
          dt_vencimento: "2023-11-10",
          dias_em_atraso: 7,
          valor_parcela: 217.13,
          valor_multa: 4.34,
          valor_mora: 1.5,
          valor_outros_contratado: 0.0,
          valor_outros_atraso: 0.0,
          valor_juros_contratado: 84.13,
          valor_juros_atraso: 0.0,
          valor_atualizado: 222.97,
          restricao_serasa: "0",
          restricao_spc: "0",
          restricao_boa_vista: "0",
          id_operacao: "00000000000032835400",
          id_sitaucao: "00",
          dt_remocao_txt: "2023-11-21",
          operacao: 3543
        },
        {
          id: 6255,
          dt_cadastro: "2023-11-13",
          last_update: "2024-01-08",
          is_deleted: true,
          cod_registro: "15",
          num_parcela: 32,
          dt_vencimento: "2023-12-10",
          dias_em_atraso: 0,
          valor_parcela: 217.13,
          valor_multa: 0.0,
          valor_mora: 0.0,
          valor_outros_contratado: 0.0,
          valor_outros_atraso: 0.0,
          valor_juros_contratado: 79.9,
          valor_juros_atraso: 0.0,
          valor_atualizado: 215.27,
          restricao_serasa: "0",
          restricao_spc: "0",
          restricao_boa_vista: "0",
          id_operacao: "00000000000032835400",
          id_sitaucao: "",
          dt_remocao_txt: "2023-11-21",
          operacao: 3543
        }
      ],
      participante_set: [],
      cod_registro: "10",
      id_operacao: "0000000000001300787",
      produto: "EMPRÉSTIMO",
      carteira: "CONSIGNAÇÃO EM FOLHA",
      valor: 10500.0,
      iof: 343.53,
      responsabilidade: "TOMADOR DA OPERAÇÃO (CRÉDITO)",
      restricao_serasa: "0",
      restricao_spc: "0",
      restricao_boa_vista: "0",
      juros: 1.13,
      mora: 2.13,
      multa: 2.0,
      valor_contabil: 7417.46,
      numero_parcelas: 72,
      dt_contratacao: "2021-03-15",
      id_numero_contrato: "0000000000001300787",
      id_operacao_cobranca: "00000000000032835400",
      id_cobranca_anterior: "",
      dt_cadastro: "2023-11-13",
      last_update: "2024-01-08",
      is_deleted: true,
      dt_remocao_txt: "2023-11-21",
      devedor: 2502
    }
  ],
  referencia_set: [
    {
      id: 6099,
      cod_registro: "05",
      nome_referencia: "",
      tipo_referencia: "Particular",
      ddd_tel1: "0043",
      num_tel1: "996030349",
      dt_cadastro: "2023-11-13",
      last_update: "2024-01-08",
      is_deleted: false,
      devedor: 2502
    },
    {
      id: 6100,
      cod_registro: "05",
      nome_referencia: "",
      tipo_referencia: "Comercial",
      ddd_tel1: "0043",
      num_tel1: "991775745",
      dt_cadastro: "2023-11-13",
      last_update: "2024-01-08",
      is_deleted: false,
      devedor: 2502
    }
  ],
  cod_registro: "01",
  cpf_cnpj: "99915839987",
  nome: "MARIA DE JESUS CELESTINO BANDEIRA",
  dt_nascimento: "1958-03-11",
  end: "DANIEL MOLINA 155",
  bairro: "CENTRO",
  municipio: "Andirá",
  uf: "PR",
  cep: "086380000",
  ddd_tel1: "0043",
  num_tel1: "999743032",
  ddd_tel2: "",
  num_tel2: "",
  ddd_tel3: "",
  num_tel3: "",
  ddd_tel4: "",
  num_tel4: "",
  email1: "cristiano_79teixeira@hotmail.com",
  email2: "",
  rg: "000000000000000000000068688388",
  dt_emissao_rg: "1993-07-08",
  orgao_emissor: "SESP",
  uf_orgao_emissor: "PR",
  nome_mae_devedor: "SENHORINHA MARIA DE JESUS",
  nome_conjuge: "ANTONIO FRANCISCO BANDEIRA",
  estado_civil: "CASADO(A)",
  nacionalidade: "BRASIL",
  id_pac: "0000000096",
  pf_pj: "PF",
  dt_cadastro: "2023-11-13",
  dt_remocao_txt: "2023-11-21",
  last_update: "2024-01-08",
  is_deleted: true
};

export const useFetchContract = id_devedor => {
  const [status, setStatus] = useState(FetchStatus.LOADING);
  const [data, setData] = useState(null);

  const fetchData = () => {
    setStatus(FetchStatus.LOADING);
    api
      .get(`/contratos/devedor/${id_devedor}`)
      .then(({ data }) => {
        setData(data);
        setStatus(FetchStatus.SUCCESS);
      })
      .catch(err => {
        console.error(err);
        setStatus(FetchStatus.ERROR);
      });
  };

  useEffect(() => {
    if (!id_devedor) return;

    fetchData();
  }, [id_devedor]);

  return {
    status,
    data,
    refetch: fetchData
  };
};



// WEBPACK FOOTER //
// ./src/pages/Pasta/Contratos/use-fetch-contracts.js